import defo from "@icelab/defo";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-toward-subtle.css";
import hljs from "highlight.js";

const views = {
  firstResponder: (el, _) => {
    el.focus();
  },
  places: (el, markers) => {
    mapboxgl.accessToken =
      "pk.eyJ1IjoiZG5pdHphIiwiYSI6ImNsZWIyY3ZzaTE0cjUzdm4xdnZ6czRlYjUifQ.FRETOXYRID6T2IoB7qqRLg";
    var map = new mapboxgl.Map({
      container: el,
      style: "mapbox://styles/mapbox/streets-v11",
      maxZoom: 8,
    });

    // const markers = JSON.parse(el.dataset["markers"]);

    const bounds = new mapboxgl.LngLatBounds(markers[0], markers[0]);

    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i]);
    }

    map.fitBounds(bounds, { padding: 60 });

    for (var i = 0; i < markers.length; i++) {
      const marker = markers[i];
      const el = document.createElement("div");
      el.className = "map-marker";

      new mapboxgl.Marker(el).setLngLat(marker).addTo(map);
    }
  },
  tada: (el, _) => {
    let confetti = new Confetti(el.id);
    confetti.setCount(200);
    confetti.setSize(2);
    confetti.setPower(20);
    confetti.setFade(true);
    confetti.destroyTarget(false);

    for (let i = 1; i < 4; i++) {
      confetti.setPower(20 * i);
      setTimeout(() => {
        const clickEvent = new Event("click");
        el.dispatchEvent(clickEvent);
      }, 500 * i);
    }
  },
  postLength: (_, attrs) => {
    const blueskySelectors = attrs.blueskyIntegrations.map(
      (idx) => `bluesky-integration-${idx}`,
    );
    const mastodonSelectors = attrs.mastodonIntegrations.map(
      (idx) => `mastodon-integration-${idx}`,
    );

    addEventListener("trix-before-initialize", (event) => {
      event.target.addEventListener("keyup", (event) => {
        if (document.querySelector(attrs.postNameSelector).value != "") {
          document
            .querySelectorAll(attrs.target)
            .forEach((el) => el.classList.add("hidden"));
        } else {
          document
            .querySelectorAll(`${attrs.target}.hidden`)
            .forEach((el) => el.classList.remove("hidden"));
        }

        const postLength = event.target.innerText.length;
        const blueskyWarning = 300;
        const mastodonWarning = 500;

        blueskySelectors.forEach((selector) => {
          document
            .querySelectorAll(`[for=${selector}] ${attrs.target}`)
            .forEach((el) => {
              el.innerText = `(${postLength} / 300)`;
              if (postLength >= blueskyWarning) {
                el.classList.add(attrs.warningClass);
              } else {
                el.classList.remove(attrs.warningClass);
              }
            });
        });

        mastodonSelectors.forEach((selector) => {
          document
            .querySelectorAll(`[for=${selector}] ${attrs.target}`)
            .forEach((el) => {
              el.innerText = `(${postLength} / 500)`;
              if (postLength >= mastodonWarning) {
                el.classList.add(attrs.warningClass);
              } else {
                el.classList.remove(attrs.warningClass);
              }
            });
        });
      });
    });
  },
};

import Confetti from "./confetti.min.js";

import "@app/builds/tailwind.css";

import Alpine from "alpinejs";
import sort from "@alpinejs/sort";
import Clipboard from "@ryangjchandler/alpine-clipboard";

import "htmx.org";

import "../css/app.css";

Alpine.plugin(sort);
Alpine.plugin(Clipboard);

// @ts-ignore
window.Alpine = Alpine;

Alpine.data("addRemove", () => {
  return {
    fields: [],
    addNewField() {
      this.fields.push({ id: new Date().getTime() + this.fields.length });
    },
    removeField(field) {
      if (typeof field === "string") {
        const ele = document.querySelector(`#${field}`);
        // @ts-ignore
        ele.parentNode.remove();
      } else {
        this.fields.splice(this.fields.indexOf(field), 1);
      }
    },
  };
});

Alpine.start();

const applyFormattingToPreBlocks = function () {
  const preElements = document.querySelectorAll("pre");
  preElements.forEach(function (preElement) {
    const regex = /(?!lang\-\\w\*)lang-\w*\W*/gm;
    const codeElement = document.createElement("code");
    if (preElement.childNodes.length > 1) {
      console.error(
        "<pre> element contained nested inline elements (probably styling) and could not be processed. Please remove them and try again.",
      );
    }
    preElement.classList.add("p-0");
    let preElementTextNode = preElement.removeChild(preElement.firstChild);
    let language = preElementTextNode.textContent.match(regex);
    if (language) {
      language = language[0].toString().trim();
      preElementTextNode.textContent = preElementTextNode.textContent.replace(
        language,
        "",
      );
      codeElement.classList.add(language, "line-numbers");
    }
    codeElement.append(preElementTextNode);
    preElement.append(codeElement);
  });

  hljs.highlightAll();
};

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const instance = defo({ views });

    applyFormattingToPreBlocks();

    // hljs.configure({ cssSelector: "pre" });

    Alpine.magic("clipboard", () => {
      return (subject) => navigator.clipboard.writeText(subject);
    });

    const changeEvent = new Event("change");
    document.body.addEventListener("htmx:afterSwap", (event) => {
      // @ts-ignore
      if (event.detail.target.id === "bookmark-url") {
        const input = document.querySelector("#bookmark-name");
        // @ts-ignore
        if (input.value == "") {
          // @ts-ignore
          input.value = JSON.parse(event.detail.xhr.response).title;
          input.dispatchEvent(changeEvent);
          // htmx.trigger(input, "changed")
        }
      }
    });
  });
})();
